import { render, staticRenderFns } from "./CommonForm.vue?vue&type=template&id=37bf8d34&scoped=true&"
import script from "./CommonForm.vue?vue&type=script&lang=js&"
export * from "./CommonForm.vue?vue&type=script&lang=js&"
import style0 from "./CommonForm.vue?vue&type=style&index=0&id=37bf8d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bf8d34",
  null
  
)

export default component.exports